import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BnNgIdleService } from 'bn-ng-idle';
import { skipInactivityUrls } from './appConstants/skipInactivityUrls';
import { ThemeService } from './appServices/theme.service';
import { UserInactivityComponent } from './includes/user-inactivity/user-inactivity.component';
import { AppInitApiService } from './core/appInit/app-init-api.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  // inactivityTime: number = 30;
  inactivityTime: number = 3000;
  inactivityModelOpened = false;
  isConnected = true;
  skipInactivityModel: boolean = false;

  constructor(
    public themeService: ThemeService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    private modalCtrl: ModalController,
    private _appInitApi: AppInitApiService
  ) {
    this.checkUrlToSkipInactivityModel();
    this.appItialization();
  }

  /**
   * intialize app
   * call required services
   */
  appItialization(): void {
    this._appInitApi.initApis();
    this.checkUserInactivity();

  }

  checkUrlToSkipInactivityModel() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (skipInactivityUrls.includes(this.router.url)) {
          this.skipInactivityModel = true;
        } else {
          this.skipInactivityModel = false;
        }
      }
    });
  }

  checkUserInactivity() {
    this.bnIdle
      .startWatching(this.inactivityTime)
      .subscribe((isTimedOut: boolean) => {
        if (
          isTimedOut &&
          !this.inactivityModelOpened &&
          !this.skipInactivityModel &&
          this.isConnected
        ) {
          this.inactivityModelOpened = true;
          this.openInactivityModel();
        }
      });
  }

  async openInactivityModel() {
    const modal = await this.modalCtrl.create({
      component: UserInactivityComponent,
      mode: 'md',
      cssClass: 'rounded-modal sml',
      backdropDismiss: false,
    });
    await modal.present();
    const { role, data } = await modal.onWillDismiss();
    if (data) {
      this.inactivityModelOpened = false;
    }
  }
}
